<script setup>
import { ref, onUpdated, defineProps, defineEmits } from "vue"
import useUsers from "../../use/useUsers"
import usePersianTools from "../../use/usePersianTools"

const props = defineProps({
  user: {
    required: true,
    type: Object,
  },
})

const userData = ref({
  id: props.user.id,
  first_name: props.user.name,
  last_name: props.user.surname,
  phone_number: props.user.phone,
  email: props.user.email,
  status: props.user.status,
})

const emit = defineEmits(["update:modelValue", "close"])

const { show, loading, errors, onSubmit, closeModal } = useUsers(
  props,
  emit,
  userData
)

const { convertPersianToEnglish } = usePersianTools()

onUpdated(() => {
  userData.value = {
    id: props.user.id,
    first_name: props.user.name,
    last_name: props.user.surname,
    phone_number: props.user.phone,
    email: props.user.email,
    status: props.user.status,
  }
})
</script>

<template>
  <!-- edit user modal  -->
  <b-modal
    v-model="show"
    @close="closeModal()"
    id="showModal"
    hide-footer
    title=" ویرایش کاربر"
    header-class="p-3 bg-light"
    class="v-modal-custom"
    centered
    no-close-on-backdrop
  >
    <b-overlay
      variant="white"
      opacity="0.75"
      blur="2px"
      :show="loading"
      spinner-variant="success"
      rounded="sm"
    >
      <b-card>
        <b-form
          id="addform"
          class="tablelist-form"
          autocomplete="off"
          @submit.prevent="onSubmit"
        >
          <div class="mb-3">
            <label for="userfirstname" class="form-label"> نام</label>
            <input
              type="text"
              id="userfirstname"
              class="form-control"
              placeholder="نام کاربر"
              v-model="userData.first_name"
            />
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.first_name">
                <span>{{ errors.first_name[0] }}</span>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label for="userlastname" class="form-label">نام خانوادگی</label>
            <input
              type="text"
              id="userlastname"
              class="form-control"
              placeholder="نام خانوادگی کاربر"
              v-model="userData.last_name"
            />
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.last_name">
                <span>{{ errors.last_name[0] }}</span>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label for="email" class="form-label">ایمیل</label>
            <input
              type="email"
              id="email"
              class="form-control"
              placeholder="آدرس ایمیل کاربر"
              v-model="userData.email"
            />
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.email">
                <span>{{ errors.email[0] }}</span>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label for="phone" class="form-label">تلفن</label>
            <input
              type="tel"
              id="phone"
              class="form-control"
              placeholder="شماره تلفن کاربر"
              v-model="userData.phone_number"
              @input="
                convertPersianToEnglish(
                  $event.target.value,
                  userData,
                  'phone_number'
                )
              "
            />
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.phone_number">
                <span>{{ errors.phone_number[0] }}</span>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label for="status" class="form-label">وضعیت</label>
            <select
              class="form-control"
              data-trigger
              id="statusfield"
              v-model="userData.status"
            >
              <option value="">وضعیت</option>
              <option value="0">غیرفعال</option>
              <option value="1">فعال</option>
            </select>
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.status">
                <span>{{ errors.status[0] }}</span>
              </div>
            </div>
          </div>

          <div class="hstack gap-2 justify-content-end">
            <b-button
              type="button"
              id="closemodal"
              variant="light"
              @click="closeModal"
            >
              بستن
            </b-button>
            <b-button type="submit" variant="success">ویرایش کاربر</b-button>
          </div>
        </b-form>
      </b-card>
    </b-overlay>
  </b-modal>
</template>
